export default function getCityType(governmentType: string) {
  return governmentType.replace(/(\b[a-z](?!\s))/g, (letter) => {
    return letter.toUpperCase();
  });

  // if (governmentType === "county") {
  //   return "County";
  // } else if (governmentType === "township") {
  //   return "Township";
  // } else {
  //   return "City";
  // }
}
